<template>
  <div class="ws-app-layout-type-a">
    <WsNavDrawer
      :items="drawerItems"
      :dropdownItems="drawerDropdownItems"
      :dropdownValue="drawerDropdownValue"
      @dropdown-input="$emit('drawer-dropdown-input',$event)"
    />
    <router-view class="view-container" />
  </div>
</template>

<script>
export default {
  name: "drawerItemsTypeA",
  props: {
    drawerItems: {
      type: Array,
    },
    drawerDropdownItems: {
      type: Array,
    },
    drawerDropdownValue: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.ws-app-layout-type-a {
  min-height: 100%;
  min-width: 100vw;
  .view-container {
    margin: 20px 20px 20px 240px;
    min-height: 680px;
    @media screen and (max-width: 1199px) {
      margin: 20px 20px 20px var(70px);
    }
  }
}
</style>